export default "__VITE_ASSET__ChAbfbEy__"